export const MIME_BINARY_FILE_CONTENT_TYPE = 'application/octet-stream';

export const SLICE_SIZE = 1024;

// Base64 characters. The index in the string is the byte-value the character corresponds to.
export const BASE64_KEY_STRING =
    'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=';
